/**
 * Funções utilitárias para manipulação de textos
 */

/**
 * Destaca parte do texto caso possua o termo passado como parâmetro
 * @param {String} term - termo que deve ser destacado
 * @param {String} text - texto que será destacado
 * @param {String} [tag='strong'] - tag que será usada como elemento do destaque
 *
 * @returns {String|Boolean} - Retorna o texto com o termo destacado ou false
 */
export const getHighlightedText = (term, text, tag = 'strong') => {
  if (!text) return false

  if (term.trim() !== '') {
    const rgx = new RegExp(term, 'gmi')

    return (
      text.toString().replace(rgx, (match) => {
        return `<${tag}>${match}</${tag}>`
      }) || false
    )
  }
}

/**
 * Converte as primeiras letras de um texto para maísculo
 * @param {String} string - String que deve ser convertido
 *
 * @returns {String} Retorna a string com as primeiras letras em maiúsculo
 */
export const capitalizeString = (string) => {
  return string
    .toLocaleLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
}

/**
 * Remove os caracteres especiais da string
 * @param {String} string - String que deve ser convertido
 *
 * @returns {String} Retorna a string sem os caracteres especiais
 */
export const removeSpecialCharacteres = (string) => {
  return string ? string.replace(/[^a-zA-Z0-9]/g, '') : string
}

/**
 * Detecta se o string está vazio
 * @param {String} string - String que será verificado
 *
 * @returns {Boolean} Retorna um valor booleano
 */
export const isEmpty = (string) => {
  return typeof string === 'string' && string.length !== 0 ? false : true
}
/**
 * Remove a acentuação de um texto
 * @param {String} string - Texto a ser alterado
 * @returns {String} Retorna o texto sem acentuação
 */
export const removeStringAccents = (string) => {
  if (!string) return ''

  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

/**
 * Padroniza um nome, no formato kebab case, para nomear arquivos. Transforma
 * os caracteres para caixa baixa, remove acentos e transforma o "&" para "e".
 *
 * @param {String} string Nome que deve ser transformado
 * @returns Nome do arquivo no formato padronizado em kebab case
 */
export const standardizeFileName = (string) => {
  if (!string) return ''

  return removeStringAccents(string || '')
    .toLowerCase()
    .replace(/&/gim, 'e')
    .replace(/[^a-z0-9\s]/gim, '')
    .replace(/\s+/gm, '-')
}

/**
 * Valida email
 * @param {String} string: Email a ser validado
 * @returns Retorna um valor booleano
 */
export const validateEmail = (string) => {
  return (
    String(string)
      .toLowerCase()
      .search(/\S+@\S+\.\S+/) > -1
  )
}
